import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CloseIcons from '../icons/menuCustom/CloseIcons';

const CircularMenu = ({ menuOptions, toggle, setToggle }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [theme, setTheme] = useState('light');

  // Retrieve theme from localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
  }, [toggle]);

  // Handle right-click event to open the menu
  const handleRightClick = (event) => {
    event.preventDefault(); // Prevent default context menu

    const adjustedX = event.clientX;
    const adjustedY = event.clientY;

    setMenuPosition({ x: adjustedX, y: adjustedY });
    setMenuVisible(true);
  };

  // Close the menu on outside click
  const handleClickOutside = () => {
    setMenuVisible(false);
  };

  useEffect(() => {
    window.addEventListener('contextmenu', handleRightClick);
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('contextmenu', handleRightClick);
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Theme-specific colors
  const themeColors = {
    light: {
      backgroundColor: '#ECEFF1',
      closeBtnColor: '#FF5252',
      iconColor: '#03A9F4',
      closeIconColor: '#ffffff',
    },
    dark: {
      backgroundColor: '#37474F',
      closeBtnColor: '#E91E63',
      iconColor: '#FFEB3B',
      closeIconColor: '#ffffff',
    },
  };

  const colors = themeColors[theme];

  return (
    <>
      <AnimatePresence>
        {menuVisible && (
          <motion.div
            className="circular-menu"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            style={{
              position: 'absolute',
              top: `${menuPosition.y}px`,
              left: `${menuPosition.x}px`,
              width: '200px',
              height: '200px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 99999, // Ensure the menu is on top of all other elements
              backgroundColor: 'transparent',
            }}
          >
            {/* Close Button */}
            <motion.div
              className="close-btn"
              onClick={() => setMenuVisible(false)}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              style={{
                position: 'absolute',
                top: '8px',
                left: '8px',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: colors.closeBtnColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                zIndex: 100000, // Ensure close button is above menu
              }}
            >
              {/* <i style={{ fontSize: '24px', color: colors.closeIconColor }}>
                <CloseIcons/>
              </i> */}
              <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill={colors.closeIconColor}
                    style={{ zIndex: 100000 }}
                  >
                    <CloseIcons/>
              </svg>
            </motion.div>

            {/* Menu Options */}
            {menuOptions.map((option, index) => {
              const angle = (360 / menuOptions.length) * index;
              const x = 70 * Math.cos((angle * Math.PI) / 180);
              const y = 70 * Math.sin((angle * Math.PI) / 180);

              return (
                <motion.div
                  key={index}
                  className="menu-btn"
                  initial={{ opacity: 0, x: 0, y: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0, x: 0, y: 0 }}
                  transition={{
                    delay: index * 0.05,
                    type: 'spring',
                    stiffness: 100,
                    damping: 10,
                  }}
                  style={{
                    position: 'absolute',
                    top: `${y}px`,
                    left: `${x}px`,
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: colors.backgroundColor,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 100000, // Ensure menu options are above everything
                  }}
                  onClick={option.onClick}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill={colors.iconColor}
                    style={{ zIndex: 100000 }}
                  >
                    {option.icon}
                  </svg>
                </motion.div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default CircularMenu;
